import React from "react";
import MarketPricePageSection from "../sections/MarketPricePageSection/Content";
const MarketPricePage = () => {
  return <MarketPricePageSection />;
};

export default MarketPricePage;
